<template>
  <el-aside class="layout-aside" width="220px">
    <el-menu :default-active="$route.path" class="menu" background-color="#0f1b2a" text-color="#cbd5e1"
      active-text-color="#f7c84b" router>

      <el-menu-item index="/dashboard">
        <i class="el-icon-data-analysis"></i>
        <span slot="title">数据统计</span>
      </el-menu-item>
      <el-menu-item index="/onboarding">
        <i class="el-icon-tickets"></i>
        <span slot="title">进件管理</span>
      </el-menu-item>
      <el-menu-item index="/orders">
        <i class="el-icon-s-order"></i>
        <span slot="title">订单管理</span>
      </el-menu-item>
      <el-menu-item index="/finance">
        <i class="el-icon-wallet"></i>
        <span slot="title">财务管理</span>
      </el-menu-item>
      <el-menu-item index="/agents" v-if="is_super == 1">
        <i class="el-icon-s-custom"></i>
        <span slot="title">代理管理</span>
      </el-menu-item>
      <el-menu-item index="/user-records" >
        <i class="el-icon-user"></i>
        <span slot="title">余额记录</span>
      </el-menu-item>
      <el-menu-item index="/settings" v-if="is_super == 1">
        <i class="el-icon-setting"></i>
        <span slot="title">系统设置</span>
      </el-menu-item>
      <el-menu-item index="/api-document">
        <i class="el-icon-document"></i>
        <span slot="title">API 文档</span>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>

<script>
export default {
  data() {
    return {
      // 维护本地状态，避免直接修改props
      localGoods: [],
      is_super: 0
    };
  },
  computed: {},
  mounted() { },
  created() {
    this.$http_get('/admin/account/info').then(res => {
      const isSuper = res && res.data ? res.data.is_super : 0;
      this.is_super = Number(isSuper) || 0;
    })
  },
  methods: {},
};
</script>

<style scoped>
.layout-aside {
  background: #0f1b2a;
  padding-top: 12px;
}

.menu {
  border-right: none;
}
</style>
